import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {AppThunk} from "../../rootReducer"
import {getAccessToken} from "../../utils/common"
import httpService from "../../utils/httpService"
import {setToastr} from "../App/appSlice"
import {Vehicle, vehicleInitial} from "../Vehicles/vehicleSlice"

type MotHistoryState = {
    searchString: string
    isRefreshButtonHidden: boolean
    isVehicleRefreshDisabled: boolean
    vehicles: Vehicle[]
    annualTests: any[]
    vehicleDetails: Vehicle
    vehicleDetailsLoading: boolean
}
const initialState: MotHistoryState = {
    searchString: "",
    isRefreshButtonHidden: false,
    isVehicleRefreshDisabled: false,
    vehicles: [],
    annualTests: [],
    vehicleDetails: vehicleInitial,
    vehicleDetailsLoading: false,
}

const motHistorySlice = createSlice({
    name: "motHistory",
    initialState,
    reducers: {
        setSearchString(state, action: PayloadAction<string>) {
            state.searchString = action.payload
        },
        setAnnualTests(state, action: PayloadAction<any[]>) {
            state.annualTests = action.payload
        },
        setVehicleDetails(state, action: PayloadAction<Vehicle>) {
            state.vehicleDetails = action.payload
        },
        toggleVehicleDetailsLoading(state, action: PayloadAction<boolean>) {
            state.vehicleDetailsLoading = action.payload
        },
        setVehicles(state, action: PayloadAction<any[]>) {
            state.vehicles = action.payload
        },
        setRefreshHiddenButton(state, action: PayloadAction<boolean>) {
            state.isRefreshButtonHidden = action.payload
        },
        setIsVehicleRefreshDisabled(state, action: PayloadAction<boolean>) {
            state.isVehicleRefreshDisabled = action.payload
        },
    },
})

export const {
    setSearchString,
    setVehicles,
    setAnnualTests,
    setVehicleDetails,
    toggleVehicleDetailsLoading,
    setRefreshHiddenButton,
    setIsVehicleRefreshDisabled,
} = motHistorySlice.actions

export default motHistorySlice.reducer

export const fetchVehicles =
    (filterText: string, checkDvsa: boolean): AppThunk =>
    (dispatch: any, getState) => {
        httpService(getAccessToken(getState()))
            .get(`vehicles/shortsearch?searchtext=${filterText}&checkDvsa=${checkDvsa}`)
            .then(res => {
                const vehicles = res.data
                dispatch(setVehicles(vehicles))
                dispatch(setRefreshHiddenButton(false))
                dispatch(setIsVehicleRefreshDisabled(false))
            })
            .catch(error => {
                dispatch(setVehicles([]))
                dispatch(setRefreshHiddenButton(true))
                dispatch(setIsVehicleRefreshDisabled(false))
                if (checkDvsa) {
                    dispatch(
                        setToastr({
                            isActive: true,
                            message: "Vehicle unavailable in DVSA",
                            delay: 3000,
                            title: "Error",
                            type: "danger",
                            description: "",
                        }),
                    )
                }
            })
    }

export const fetchVehicleAnnualTests =
    (vehicleId: number): AppThunk =>
    (dispatch: any, getState) => {
        httpService(getAccessToken(getState()))
            .get(`vehicles/annual-tests/${vehicleId}`)
            .then(res => {
                const vehicleAnnualTests = res.data
                if (vehicleAnnualTests.length > 0) {
                    dispatch(setAnnualTests(vehicleAnnualTests[0].annualTests))
                    dispatch(setVehicleDetails(vehicleAnnualTests[0]))
                } else dispatch(setAnnualTests([]))
            })
            .catch(error => dispatch(setAnnualTests([])))
            .finally(() => dispatch(toggleVehicleDetailsLoading(false)))
    }
